export const tokens = {
  primary: {
    main: '#1A2F4A',
    dark: '#13233A',
  },
  secondary: {
    main: '#FF8A3D',
    soft: '#FFE0C3',
  },
  text: {
    main: '#222222',
    sub: '#666666',
    muted: '#9AA4B2',
    onDark: '#FFFFFF',
  },
  border: {
    light: '#E7EAF0',
    medium: '#CCD3E0',
  },
  bg: {
    base: '#FFFFFF',
    soft: '#F4F7FA',
    section: '#F8FAFD',
    icon: '#EAF3FF',
  },
};
